module.exports = __webpack_public_path__ + "img/Norway.b92ad796.svg";